import React, { Component } from 'react';
import { document } from 'browser-monads';
import { Link } from 'gatsby';
import RichText from 'components/RichText';
import Content from 'components/_ui/Content';
import styled from '@emotion/styled';
import dimensions from 'styles/dimensions';
import { Inner } from 'styles/structure';
import { Rubric } from 'styles/typography';
import colors from 'styles/colors';
import arrow from 'images/caption-arrow.png';
import Button from 'components/_ui/Button';

const PitchContainer = styled.div`
  position: relative;
  display: block;
  background-color: ${colors.orange100};
  padding: 8rem 0 4.8rem;
  
  header {
    text-align: center;
    
    h3 {
      max-width: 108rem;
      margin: 0 auto;
    } 
    
    & + * {
      margin-top: 3.2rem;
    }
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    padding: 10.4rem 0 12.4rem;
  
    header {
      & + * {
        margin-top: 10.4rem;
      }
    }
  }
`;

const PitchWrap = styled.div`
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
  }
`;

const PitchContent = styled.div`
  > a {
    margin-top: 4.8rem;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    flex: 1 1 50%;
    max-width: 46.8rem;
    
    p {
      max-width: 90%;
    }
  }
  
  @media(min-width: ${dimensions.desktopUp}px) {
    p {
      font-size: 2.1rem;
    }
  }
`;

const PitchMedia = styled.div`
  & + * {
    margin-top: 3.2rem;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    flex: 2 1 62rem;
    margin-right: 8rem;
    
    .Pitch--right & {
      order: 2;
      margin-right: 0;
      margin-left: 8rem;
    }
    
      & + * {
        margin-top: 0;
      }
  }
`;

const PitchVideo = styled.div``;

const PitchCaption = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.2rem;
  
  text-align: center;
  
  div {
    position: relative;
    padding-top: 3.6rem;
    width: 56.25vw;
    max-width: 32rem;
  }
  
  img {
    position: absolute;
    top: 0;
    right: 4.8rem;
    width: 0.9rem; 
    height: 2.6rem;
  }
  
  p {
    color: ${colors.teal200};
  }
`;

class HomepagePitch extends Component {
  componentDidMount() {
    const script = document.createElement('script');
    script.src = 'https://editorial.anyclip.com/anyclip-widget/lre-widget/prod/v1/src/lre.js';
    script.setAttribute('pubname', 'anyclipsitecom');
    script.setAttribute('widgetname', this.props.widget);
    script.async = true;
    this.playerNode.appendChild(script);
  }

  render() {
    return (
      <PitchContainer
        id='watch'
        className={this.props.videoPosition && `Pitch--${this.props.videoPosition}`}
      >
        <Inner>
          <header>
            {this.props.rubric && <Rubric>{this.props.rubric}</Rubric>}
            <h2>{this.props.heading}</h2>
          </header>

          <PitchWrap>
            <PitchMedia>
              <PitchVideo
                ref={node => this.playerNode = node}
              />

              {this.props.caption && (
                <PitchCaption>
                  <div>
                    <img src={arrow} alt='' loading="lazy" />
                    <RichText render={this.props.caption}/>
                  </div>
                </PitchCaption>
              )}
            </PitchMedia>

            <PitchContent>
              {this.props.content && <Content content={this.props.content}/>}

              {(this.props.buttonDestination && this.props.buttonText) && (
                <Button as={Link} to={this.props.buttonDestination}>
                  <span>{this.props.buttonText}</span>
                </Button>
              )}
            </PitchContent>
          </PitchWrap>
        </Inner>
      </PitchContainer>
    );
  }
};

export default HomepagePitch;
